export const IGNORE_OCR_FIELDS = {
  fileUrl: true,
  isSameWithOCR: true,
};
